// eslint-disable-next-line no-use-before-define
import React, { Suspense } from 'react';
import {
  Form,
  Table,
  Divider,
  DatePicker,
  Select,
  Badge,
  Card,
  Tabs,
  Col,
  Row,
  Radio,
  notification,
  Button,
  Switch,
  Input,
  InputNumber,
  message,
  Typography,
  Modal,
} from 'antd';
import moment from 'moment';

import  './index.less';
import { calculate } from 'services/finEngine';
import DF from 'DisplayFramework';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ICalculator from 'icons/ICalculator';
import { getCurrentPageDisplay } from 'services/displayFramework';
import { sumBy } from 'lodash';
import ModalControllerNV from 'components/ModalControllerNV';
import { toCurrency, toCoef, toRate, toFormaterCurrency } from 'utils/utils';
import UtinaCard from 'components/UtinaCard';
import FormInput from 'components/FormInput';

const { TabPane } = Tabs;
const { Text } = Typography;
const { Cell } = Table.Summary;

class Calculator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currcode: localStorage.getItem('currcode') ?? '',
      paymentSchedule: [],
      fundingSchedule: [],
      fwDisplay: [],
      calStatusColor: '#722ED1',
      firstRental: 0,
      firstRentalPerc: 0,
      finAmount: 0,
      InvestAmount: 0,
      oemPartAmount: 0,
      oemPartMethod: 'REDUCEFIN',
      dealerPartAmount: 0,
      dealerPartMethod: 'REDUCEFIN',
      commissionAmount: 0,
      duration: 24,
      upFront: 0,
      periodicity: 1,
      unit: 'M',
      term: 'ADVANCE',
      interestMethod: 'BOP',
      gpDuration: 0,
      gpMethod: 'CAP',
      gpPeriodicity: 1,
      installment: 0,
      rentalAmount: 0,
      rv: 0,
      rvPerc: 0,
      taxrate: 20,
      taxtype: 'RENTAL',
      ratePeriodicity: 1,
      rateType: 'NOMINAL',
      countingBasis: '360',
      rateValue: 6,
      nominalRate: 0,
      effectiveRate: 0,
      rate000: 0,
      flatRate: 0,
      startDate: moment().format('YYYY-MM-DD'),
      rounding: 2,
      billingDate: '1',
      deferredMethod: 'INTINVOICE', // 3 values : INTINVOICE, RENTALPART , CAP
      deferredRate: 10,
      deferredAmount: 0, // result of calculation
      depositMethod: 'REDUCEINT', // 2 values : REDUCEINT, NONE
      depositAmount: 0,
      depositRate: 5,
      depositInterest: 0, // result of calculation
      feesAmount: 0,
      profitabilityRate: 0,
      profitabilityAmount: 0,
      aprRate: 0,
      totalInterest: 0,
      totalFundingInterest: 0,
      totalRental: 0,
      totalAmortization: 0,
      totalVatDeffered: 0,
      totaldiscountedInterest: 0,
      totaldiscountedOutstanding: 0,
      totaldiscountedAgiosdeb: 0,
      totalAgiosdeb: 0,
      marginImpactCredit: 0,
      marginImpactDebit: 0,
      dgo: 0,
      fundingInstallment: 0,
      fundingRate: 3,
      spread: 3,
      fundingPeriodicity: 1,
      vatDuration: 3,
      vatAmount: 0,
      vatDaysBasis: '365',
      vatMethod: 'SPLIT',
    };
  }

  form = React.createRef();

  componentDidMount() {
    this.loadDisplay('calculator');
  }

  onStartDateChange = (value) => {
    const sdate = moment(value).format('YYYY-MM-DD');
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      startDate: sdate,
    });
  };

  onBilligDateChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      billingDate: value,
    });
  };

  onDeferredMethodChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      deferredMethod: value,
    });
  };

  onDeferredRatehange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      deferredRate: value,
    });
  };

  onVatAmounthange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      vatAmount: value,
    });
  };

  onVatDurationhange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      vatDuration: value,
    });
  };

  onDepositMethodchange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      depositMethod: value,
    });
  };

  onDepositAmountchange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      depositAmount: value,
    });
  };

  onDepositRatechange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      depositRate: value,
    });
  };

  onRoundingChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      rounding: value,
    });
  };

  onInvestAmountChange = (value) => {
    let partamount = this.state.partAmount;

    if (this.state.partMethod !== 'REDUCEFIN') {
      partamount = 0;
    }
    const finAmount = value - this.state.upFront - partamount;

    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      InvestAmount: value,
      finAmount,
    });
  };

  onDurationChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      duration: value,
    });
  };

  onSpreadChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      spread: value,
      rateValue: this.state.fundingRate + value,
      rateType: 'NOMINAL',
      nominalRate: this.state.fundingRate + value,
    });

    this.form.current.setFieldsValue({
      rateType: 'NOMINAL',
      rateValue: this.state.fundingRate + value,
    });
  };
  onFundingRateChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      fundingRate: value,
    });
  };

  onFundingPeriodicityChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      fundingPeriodicity: value,
    });
  };

  onUpFrontChange = (value) => {
    let partamount = this.state.partAmount;

    if (this.state.partMethod !== 'REDUCEFIN') {
      partamount = 0;
    }
    const finAmount = this.state.InvestAmount - value - partamount;

    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      upFront: value,
      finAmount,
    });
  };

  onFeesChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      feesAmount: value,
    });
  };

  onCommissionAmountChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      commissionAmount: value,
    });
  };

  onVatAmountChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      vatAmount: value,
    });
  };

  onVatMethodChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      vatMethod: value,
    });
  };

  onVatDaysBasisChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      vatDaysBasis: value,
    });
  };
  onVatDurationChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      vatDuration: value,
    });
  };

  onOemPartAmountChange = (value) => {
    let oempartamount = value;
    let dealerpartamount = this.state.dealerPartAmount;
    let dealerPartMethod = this.state.dealerPartMethod;
    if (dealerPartMethod !== 'REDUCEFIN') {
      dealerpartamount = 0;
    }

    if (this.state.oemPartMethod !== 'REDUCEFIN') {
      oempartamount = 0;
    }

    const finAmount =
      this.state.InvestAmount -
      this.state.upFront -
      dealerpartamount -
      oempartamount;

    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      oemPartAmount: value,
      finAmount,
    });
  };
  onDealerPartAmountChange = (value) => {
    let dealerpartamount = value;
    let oempartamount = this.state.oemPartAmount;
    let dealerPartMethod = this.state.dealerPartMethod;

    if (dealerPartMethod !== 'REDUCEFIN') {
      dealerpartamount = 0;
    }

    if (this.state.oemPartMethod !== 'REDUCEFIN') {
      oempartamount = 0;
    }

    const finAmount =
      this.state.InvestAmount -
      this.state.upFront -
      dealerpartamount -
      oempartamount;

    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      dealerPartAmount: value,
      finAmount,
    });
  };

  onOemPartMethodChange = (value) => {
    let oempartamount = this.state.oemPartAmount;
    let dealerpartamount = this.state.dealerPartAmount;
    let dealerPartMethod = this.state.dealerPartMethod;
    if (dealerPartMethod !== 'REDUCEFIN') {
      dealerpartamount = 0;
    }

    if (value !== 'REDUCEFIN') {
      oempartamount = 0;
    }
    const finAmount =
      this.state.InvestAmount -
      this.state.upFront -
      oempartamount -
      dealerpartamount;

    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      oemPartMethod: value,
      finAmount,
    });
  };
  onDealerPartMethodChange = (value) => {
    let oempartamount = this.state.oemPartAmount;
    let dealerpartamount = this.state.dealerPartAmount;
    let oemPartMethod = this.state.oemPartMethod;
    if (oemPartMethod !== 'REDUCEFIN') {
      oempartamount = 0;
    }

    if (value !== 'REDUCEFIN') {
      dealerpartamount = 0;
    }
    const finAmount =
      this.state.InvestAmount -
      this.state.upFront -
      oempartamount -
      dealerpartamount;

    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      finAmount,
    });
  };

  onTaxtypeChange = (value) => {
    let taxtype = 'RENTAL';

    if (value === true) {
      taxtype = 'RENTAL';
    } else {
      taxtype = 'INT';
    }

    this.setState({ paymentSchedule: [], calStatusColor: 'red', taxtype });
  };

  onTaxrateChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      taxrate: value,
    });
  };

  onPeriodicityChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      periodicity: value,
    });
  };

  onGpPeriodicityChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      gpPeriodicity: value,
    });
  };

  onUnitChange = (value) => {
    this.setState({ paymentSchedule: [], calStatusColor: 'red', unit: value });
  };

  onTermChange = (e) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      term: e.target.value,
    });
  };

  onGPDurationChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      gpDuration: value,
    });
  };

  onGPMethodChange = (e) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      gpMethod: e.target.value,
    });
  };

  onInstallmentChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      installment: value,
    });
  };

  onInterestMethodChange = (e) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      interestMethod: e.target.value,
    });
  };

  onRatePeriodicityChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      ratePeriodicity: value,
    });
  };

  onRateTypeChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      rateType: value,
    });
  };

  onProfitabilityRateChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      profitabilityRate: value,
    });
  };

  onRateValueChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      rateValue: value,
    });
  };

  onCountingBasisChange = (value) => {
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      countingBasis: value,
    });
  };

  onFirstRentalChange = (value) => {
    const { finAmount } = this.state;
    let firstRentalPerc = 0;

    if (finAmount > 0) {
      firstRentalPerc = (value / finAmount) * 100;
    }
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      firstRental: value,
      firstRentalPerc,
    });
  };

  onFirstRentalPercChange = (value) => {
    const { finAmount } = this.state;
    const firstRental = (finAmount * value) / 100;
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      firstRental,
      firstRentalPerc: value,
    });
  };

  onRVChange = (value) => {
    const finAmount = this.state.InvestAmount;
    let rvPerc = 0;

    if (finAmount > 0) {
      rvPerc = (value / finAmount) * 100;
    }
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      rv: value,
      rvPerc,
    });
  };

  onRVPercChange = (value) => {
    const finAmount = this.state.InvestAmount;
    const rv = (finAmount * value) / 100;
    this.setState({
      paymentSchedule: [],
      calStatusColor: 'red',
      rv,
      rvPerc: value,
    });
  };

  calculate = (method) => {
    let lmethod = method;
    if (method === 'PARTOEM') {
      lmethod = 'PART';
    }

    if (method === 'PARTDEAL') {
      lmethod = 'PART';
    }

    const FinCalculationRequest = {
      inBillingDate: this.state.billingDate,
      inCalculationMethod: lmethod,
      inCountingbasis: this.state.countingBasis,
      inDeferredMethod: this.state.deferredMethod,
      inDeferredRate: this.state.deferredRate,
      inDepositAmount: this.state.depositAmount,
      inDepositMethod: this.state.depositMethod,
      inDepositRate: this.state.depositRate,
      inDuration: this.state.duration,
      inFinancedAmount: this.state.finAmount,
      inFirstInstallmentDate: null,
      inFirstPayment: this.state.firstRental,
      inGracePeriodDuration: this.state.gpDuration,
      inGracePeriodMethod: this.state.gpMethod,
      inInstallmentAmount: this.state.installment,
      inInterestMethod: this.state.interestMethod,
      inPartAmount: 0,
      inPartMethod: 'NONE',
      inPartNbDays: 0,
      inPartRate: 0,
      inPeriodicity: this.state.periodicity,
      inGracePeriodPeriodicity: this.state.gpPeriodicity,
      inPeriodicityUnit: this.state.unit,
      inRatePeriodicity: this.state.ratePeriodicity,
      inRateType: this.state.rateType,
      inRateValue: this.state.rateValue,
      inResidualValue: this.state.rv,
      inRoundingAmount: this.state.rounding,
      inRoundingRate: 9,
      inStartDate: this.state.startDate,
      inTaxcode: 'NORM',
      inTaxrate: this.state.taxrate,
      inTaxtype: this.state.taxtype,
      inTerm: this.state.term,
      inUpFrontAmount: this.state.upFront,
      inFeesAmount: this.state.feesAmount,
      inDealerPartAmount: this.state.dealerPartAmount,
      inManufacturerPartAmount: this.state.oemPartAmount,
      inCommissionAmount: this.state.commissionAmount,
      inProfitabilityRate: this.state.profitabilityRate,
      inFundingRate: this.state.fundingRate,
      inFundingPeriodicity: this.state.fundingPeriodicity,
      inVatAmount: this.state.vatAmount,
      inVatDuration: this.state.vatDuration,
      inVatDaysBasis: this.state.vatDaysBasis,
      inVatMethod: this.state.vatMethod,
    };

    calculate({ finReq: FinCalculationRequest })
      .then((response) => {
        if (response.status === '500') {
          notification.error({
            message: response.message,
            duration: 0,
          });
        } else {
          let oempartamount = this.state.oemPartAmount;
          let dealerpartamount = this.state.dealerPartAmount;
          if (method === 'PARTOEM') {
            oempartamount = response.partAmount - dealerpartamount;
          } else {
            if (method === 'PARTDEAL') {
              dealerpartamount = response.partAmount - oempartamount;
            }
          }

          this.setState({
            paymentSchedule: response.paymentSchedule,
            fundingSchedule: response.fundingSchedule,
            nominalRate: response.nominalrate,
            effectiveRate: response.effectiverate,
            installment: response.installmentamount,
            rv: response.residualvalue,
            duration: response.duration,
            finAmount: response.financedamount,
            partAmount: response.partAmount,
            oemPartAmount: oempartamount,
            dealerPartAmount: dealerpartamount,
            commissionAmount: response.commissionAmount,
            deferredAmount: response.deferredInterest,
            depositInterest: response.depositInterest,
            rentalAmount: response.installmentamount - response.depositInterest,
            aprRate: response.aprRate,
            flatRate: response.flatRate,
            rate000: response.rate000,
            profitabilityRate: response.profitabilityRate,
            calStatusColor: '#52c41a',
            totalInterest: response.totalInterest,
            totalRental: response.totalRental,
            totalAmortization: response.totalAmortization,
            totaldiscountedInterest: response.totaldiscountedInterest,
            totalVatDeffered: response.totalVatDeffered,
            totaldiscountedOutstanding: response.totaldiscountedOutstanding,
            totaldiscountedAgiosdeb: response.totaldiscountedAgiosdeb,
            totalAgiosdeb: response.totalAgiosdeb,
            marginImpactCredit: response.marginImpactCredit,
            marginImpactDebit: response.marginImpactDebit,
            dgo: response.dgo,
            profitabilityAmount:
              sumBy(response.paymentSchedule, 'ctsinterestamount') ??
              0 + this.state.feesAmount ??
              0 + response.parAmount ??
              0 - response.commissionAmount ??
              0,
            fundingInstallment: response.fundingInstallment ?? 0,
            totalFundingInterest:
              sumBy(response.fundingSchedule, 'ctsinterestamount') ?? 0,
          });

          this.form.current.setFieldsValue({
            profitabilityRate: response.profitabilityRate,
            oemPartAmount: oempartamount,
            dealerPartAmount: dealerpartamount,
          });

          switch (this.state.rateType) {
            case 'RATE000':
              this.form.current.setFieldsValue({ rateValue: response.rate000 });
              break;
            case 'NOMINAL':
              this.form.current.setFieldsValue({
                rateValue: response.nominalrate,
              });
              break;
            case 'EFFECTIVE':
              this.form.current.setFieldsValue({
                rateValue: response.effectiverate,
              });
              break;
            case 'FLAT':
              this.form.current.setFieldsValue({
                rateValue: response.flatRate,
              });
              break;
            case 'APRRATE':
              this.form.current.setFieldsValue({ rateValue: response.aprRate });
              break;

            case 'PROFRATE':
              this.form.current.setFieldsValue({
                rateValue: response.profitabilityRate,
              });
              break;
          }
          message.success(response.message);
        }
      })
      .catch((err) => {
        message.error('Calculation Error : ' + err.message);
      });
  };

  loadDisplay = (param) => {
    getCurrentPageDisplay({
      pagcode: param,
      entity: undefined,
      entityid: undefined,
    }).then((response) => {
      this.setState({
        fwDisplay: response?.list,
      });
    });
  };

  getComLabel = function (key) {
    let title;
    if (this.state.fwDisplay?.length > 0) {
      try {
        title = this.state.fwDisplay.find((el) => el.comcode === key).comlabel;
      } catch (error) {
        title = `##${key}`;
      }
    }
    return title;
  };

  getComPlaceHolder = function (key) {
    let title;
    if (this.state.fwDisplay?.length > 0) {
      try {
        title = this.state.fwDisplay.find(
          (el) => el.comcode === key
        ).complaceholder;
      } catch (error) {
        title = `##${key}`;
      }
    }

    return title;
  };

  getComDisplay = function (key) {
    let hidden;
    if (this.state.fwDisplay?.length > 0) {
      try {
        hidden = this.state.fwDisplay.find((el) => el.comcode === key).flaghide;
      } catch (error) {
        hidden = false;
      }
    }

    return hidden;
  };

  render() {
    const getRespColumnsPS = (smallScreen) =>
      columnsPS.filter(({ hide = false }) => !hide);

    const columnsPS = [
      {
        title: this.getComLabel('psorder'),
        dataIndex: 'ctsorder',
        width: '50px',
        fixed: 'left',
        hide: this.getComDisplay('psorder'),
      },
      {
        title: this.getComLabel('pstype'),
        dataIndex: 'ctstype',
        fixed: 'left',
        width: '100px',
        hide: this.getComDisplay('pstype'),
      },
      {
        title: this.getComLabel('psduedate'),
        dataIndex: 'ctsduedate',
        fixed: 'left',
        width: '100px',
        hide: this.getComDisplay('psduedate'),
      },
      {
        title: this.getComLabel('psstartamount'),
        dataIndex: 'ctsstartamount',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psstartamount'),
      },
      {
        title: this.getComLabel('vatdeffered'),
        dataIndex: 'ctsvatdeffered',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('vatdeffered'),
      },
      {
        title: this.getComLabel('psamortizedamount'),
        dataIndex: 'ctsamortizedamount',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psamortizedamount'),
      },
      {
        title: this.getComLabel('psinterestamount'),
        dataIndex: 'ctsinterestamount',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psinterestamount'),
      },
      {
        title: this.getComLabel('psoutstandingamount'),
        dataIndex: 'ctsoutstandingamount',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psoutstandingamount'),
      },
      {
        title: this.getComLabel('psdiscountCoef'),
        dataIndex: 'ctsdiscountcoef',
        width: '100px',
        align: 'right',
        render: (text, record) => toCoef(record.ctsdiscountcoef),
        hide: this.getComDisplay('psdiscountCoef'),
      },

      {
        title: this.getComLabel('psdiscountoutstanding'),
        dataIndex: 'ctsdiscountoutstanding',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psdiscountoutstanding'),
      },
      {
        title: this.getComLabel('psdiscountinterest'),
        dataIndex: 'ctsdiscountinterest',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psdiscountinterest'),
      },
      {
        title: this.getComLabel('ctsagiosdeb'),
        dataIndex: 'ctsagiosdeb',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('ctsagiosdeb'),
      },
      {
        title: this.getComLabel('ctsdiscountagiosdeb'),
        dataIndex: 'ctsdiscountagiosdeb',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('ctsdiscountagiosdeb'),
      },
      {
        title: this.getComLabel('ctsdepositinterest'),
        dataIndex: 'ctsdepositinterest',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('ctsdepositinterest'),
      },
      {
        title: this.getComLabel('ctsrentalincDeposit'),
        dataIndex: 'ctsrentalincDeposit',
        width: '200px',
        align: 'right',
        render: (text, record) =>
          toCurrency(
            record.ctsrentalamount - record.ctsdepositinterest,
            this.state.currcode
          ),
        hide: this.getComDisplay('ctsrentalincDeposit'),
      },
      {
        title: this.getComLabel('ctstaxamount'),
        dataIndex: 'ctstaxamount',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('ctstaxamount'),
      },
      {
        title: this.getComLabel('ctstotalamount'),
        dataIndex: 'ctstotalamount',
        width: '200px',
        align: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('ctstotalamount'),
      },
      {
        title: this.getComLabel('psstartdate'),
        dataIndex: 'ctsstartdate',
        width: '100px',
        hide: this.getComDisplay('psstartdate'),
      },
      {
        title: this.getComLabel('psenddate'),
        dataIndex: 'ctsenddate',
        width: '100px',
        hide: this.getComDisplay('psenddate'),
      },
      {
        title: this.getComLabel('psrentalamount'),
        dataIndex: 'ctsrentalamount',
        width: '200px',
        align: 'right',
        fixed: 'right',
        render: (text, record) => toCurrency(text, this.state.currcode),
        hide: this.getComDisplay('psrentalamount'),
      },
    ];

    const tabExtra = <div></div>;

    const contentCalculator = (
      <Form ref={this.form}>
        <Suspense fallback={null}>
          <Card>
            <Tabs
              type="card"
              style={{ height: '800px' }}
              tabBarExtraContent={tabExtra}
            >
              <TabPane
                forceRender
                tab={
                  <Badge style={{ backgroundColor: '#52c41a' }}>
                    <GetLabel label="calculator" />
                  </Badge>
                }
                key="1"
              >
                <Row gutter={16}>
                  <Col span={6}>
                    <UtinaCard comcode="finttributes" level={5}>
                      <Row gutter={8}>
                        <FormInput col xs={24} name="startdate">
                          <DatePicker
                            size="middle"
                            defaultValue={moment()}
                            value={moment(this.state.startDate)}
                            onChange={this.onStartDateChange}
                          />
                        </FormInput>
                        <FormInput col xs={24} name="billingDate">
                          <Select
                            defaultValue="1"
                            size="middle"
                            onChange={this.onBilligDateChange}
                          >
                            <option value="1">1st day of month</option>
                            <option value="5">5th day of month</option>
                            <option value="10">10th day of month</option>
                            <option value="15">15th day of month</option>
                            <option value="20">20th day of month</option>
                            <option value="25">25th day of month</option>
                            <option value="30">25th day of month</option>
                            <option value="EOM">End of Month</option>
                          </Select>
                        </FormInput>
                      </Row>
                      <Row>
                        <FormInput col xs={24} name="rounding">
                          <InputNumber
                            defaultValue={2}
                            size="middle"
                            min={0}
                            max={3}
                            step={1}
                            value={this.state.rounding}
                            onChange={this.onRoundingChange}
                          />
                        </FormInput>
                        <FormInput col xs={24} name="depositMethod">
                          <Select
                            defaultValue="NONE"
                            size="middle"
                            onChange={this.onDepositMethodchange}
                          >
                            <option value="NONE">None</option>
                            <option value="CAP">Capitalization</option>
                            <option value="REDUCEINT">
                              Reduce Installment Interest
                            </option>
                          </Select>
                        </FormInput>
                        <FormInput col xs={24} name="depositAmount">
                          <InputNumber
                            defaultValue={0}
                            size="middle"
                            value={this.state.depositAmount}
                            onChange={this.onDepositAmountchange}
                          />
                        </FormInput>
                        <FormInput col xs={24} name="depositRate">
                          <InputNumber
                            defaultValue={0}
                            size="middle"
                            value={this.state.depositRate}
                            onChange={this.onDepositRatechange}
                          />
                        </FormInput>
                        <FormInput col xs={24} name="deferredMethod">
                          <Select
                            defaultValue="INTINVOICE"
                            size="middle"
                            style={{ width: '100%' }}
                            onChange={this.onDeferredMethodChange}
                          >
                            <option value="INTINVOICE">
                              Interest to Invoice with 1st installment
                            </option>
                            <option value="CAP">Interest to capitalize</option>
                            <option value="RENTALPART">
                              Invoice a fraction of rental for nb of days
                            </option>
                          </Select>
                        </FormInput>
                        <FormInput col xs={24} name="defferedRate">
                          <InputNumber
                            defaultValue={2}
                            size="middle"
                            min={0}
                            max={50}
                            step={0.01}
                            value={this.state.deferredRate}
                            onChange={this.onDeferredRatehange}
                          />
                        </FormInput>
                        <FormInput col xs={24} name="deferredInterest">
                          <Text type="danger">
                            {toCurrency(
                              this.state.deferredAmount,
                              this.state.currcode
                            )}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="depositInterest">
                          <Text type="danger">
                            {toCurrency(
                              this.state.depositInterest,
                              this.state.currcode
                            )}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="rentalIncDeposit">
                          <Text type="danger">
                            {toCurrency(
                              this.state.rentalAmount,
                              this.state.currcode
                            )}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="totalInterest">
                          <Text type="danger">
                            {toCurrency(
                              this.state.totalInterest,
                              this.state.currcode
                            )}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="totalRental">
                          <Text type="danger">
                            {toCurrency(
                              this.state.totalRental,
                              this.state.currcode
                            )}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="dgo">
                          <Text type="danger">
                            {toCurrency(this.state.dgo, this.state.currcode)}
                          </Text>
                        </FormInput>
                      </Row>
                    </UtinaCard>
                  </Col>
                  <Col span={12}>
                    <UtinaCard comcode="finPlan" level={5}>
                      <Row gutter={16}>
                        <FormInput col xs={12} name="investAmount">
                          <Input.Group compact>
                            <InputNumber
                              size="middle"
                              value={this.state.InvestAmount}
                              onChange={this.onInvestAmountChange}
                              style={{ width: '120px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <Button
                              type="default"
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              size="middle"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('FINANCING');
                              }}
                            />
                          </Input.Group>
                        </FormInput>
                        <FormInput col xs={12} name="taxrate">
                          <Input.Group compact>
                            <InputNumber
                              size="middle"
                              value={this.state.taxrate}
                              onChange={this.onTaxrateChange}
                              style={{ width: '80px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <Switch
                              checkedChildren="Tax on Rental"
                              unCheckedChildren="Tax on Interest"
                              defaultChecked
                              onChange={this.onTaxtypeChange}
                            >
                              <GetLabel label="TaxonInterest" />
                            </Switch>
                          </Input.Group>
                        </FormInput>
                      </Row>

                      <Row gutter={16}>
                        <FormInput col xs={12} name="upfront">
                          <InputNumber
                            value={this.state.upFront}
                            size="middle"
                            onChange={this.onUpFrontChange}
                            style={{ width: '120px' }}
                            formatter={(value) => toFormaterCurrency(value)}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                          />
                        </FormInput>
                        <FormInput col xs={12} name="duration">
                          <Input.Group compact>
                            <InputNumber
                              defaultValue={24}
                              value={this.state.duration}
                              size="middle"
                              min={1}
                              max={360}
                              step={1}
                              onChange={this.onDurationChange}
                            />
                            <Button
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('DURATION');
                              }}
                              size="middle"
                            />
                          </Input.Group>
                        </FormInput>
                      </Row>
                      <Row gutter={8}>
                        <FormInput col xs={12} name="fees">
                          <InputNumber
                            value={this.state.feesAmount}
                            size="middle"
                            onChange={this.onFeesChange}
                            style={{ width: '120px' }}
                            formatter={(value) => toFormaterCurrency(value)}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                          />
                        </FormInput>
                        <FormInput col xs={12} name="commission">
                          <Input.Group compact>
                            <InputNumber
                              defaultValue={0}
                              value={this.state.commissionAmount}
                              size="middle"
                              onChange={this.onCommissionAmountChange}
                            />
                            <Button
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('COMM');
                              }}
                              size="middle"
                            />
                          </Input.Group>
                        </FormInput>
                      </Row>
                      <Row gutter={8}>
                        <FormInput col xs={12} name="dealerParticipation">
                          <Input.Group compact>
                            <InputNumber
                              defaultValue={0}
                              value={this.state.dealerPartAmount}
                              size="middle"
                              onChange={this.onDealerPartAmountChange}
                              style={{ width: '120px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <Button
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('PARTDEAL');
                              }}
                              size="middle"
                            />
                          </Input.Group>
                        </FormInput>
                        <FormInput col xs={12} name="dealerPartMethod">
                          <Select
                            defaultValue="REDUCEFIN"
                            size="middle"
                            onChange={this.onDealerPartMethodChange}
                          >
                            <option value="FLAT"> Flat</option>
                            <option value="REDUCEFIN">
                              {' '}
                              Reduce Fin. amount
                            </option>
                          </Select>
                        </FormInput>
                      </Row>
                      <Row gutter={8}>
                        <FormInput col xs={12} name="oemPartAmount">
                          <Input.Group compact>
                            <InputNumber
                              defaultValue={0}
                              value={this.state.oemPartAmount}
                              size="middle"
                              onChange={this.onOemPartAmountChange}
                              style={{ width: '120px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <Button
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('PARTOEM');
                              }}
                              size="middle"
                            />
                          </Input.Group>
                        </FormInput>
                        <FormInput col xs={12} name="oemPartMethod">
                          <Select
                            defaultValue="REDUCEFIN"
                            size="middle"
                            onChange={this.onOemPartMethodChange}
                          >
                            <option value="FLAT"> Flat</option>
                            <option value="REDUCEFIN">
                              {' '}
                              Reduce Fin. amount
                            </option>
                          </Select>
                        </FormInput>
                      </Row>

                      <Row gutter={8}>
                        <FormInput col xs={12} name="financedAmount">
                          <Text strong type="warning">
                            {`${this.state.finAmount}`.replace(
                              /\B(?=(\d{3})+(?!\d))/g,
                              ','
                            )}
                          </Text>
                        </FormInput>

                        <FormInput col xs={12} name="periodicity">
                          <Input.Group>
                            <Select
                              defaultValue="1"
                              size="middle"
                              onChange={this.onPeriodicityChange}
                            >
                              <option value="1"> 1</option>
                              <option value="2"> 2</option>
                              <option value="3"> 3</option>
                              <option value="6"> 6</option>
                              <option value="12"> 12</option>
                            </Select>
                            <Select
                              defaultValue="M"
                              size="middle"
                              onChange={this.onUnitChange}
                            >
                              <option value="M"> Month</option>
                              <option value="Q"> Quarter</option>
                              <option value="S"> Semester</option>
                              <option value="Y"> Year</option>
                              <option value="D"> Day</option>
                            </Select>
                          </Input.Group>
                        </FormInput>
                      </Row>
                      <Row gutter={8}>
                        <FormInput col xs={12} name="firstRental">
                          <Input.Group compact>
                            <InputNumber
                              size="middle"
                              defaultValue={0}
                              value={this.state.firstRental}
                              onChange={this.onFirstRentalChange}
                              style={{ width: '120px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <InputNumber
                              style={{ width: '70px' }}
                              size="middle"
                              defaultValue={0}
                              value={this.state.firstRentalPerc}
                              min={0}
                              max={100}
                              formatter={(value) => `${value}%`}
                              parser={(value) => value.replace('%', '')}
                              onChange={this.onFirstRentalPercChange}
                            />
                          </Input.Group>
                        </FormInput>
                      </Row>

                      <Row gutter={8}>
                        <FormInput col xs={12} name="installment">
                          <Input.Group compact>
                            <InputNumber
                              size="middle"
                              value={this.state.installment}
                              onChange={this.onInstallmentChange}
                              style={{ width: '120px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <Button
                              type="default"
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              size="middle"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('INST');
                              }}
                            />
                          </Input.Group>
                        </FormInput>
                        <FormInput col xs={12} name="term">
                          <Radio.Group
                            size="middle"
                            defaultValue="ADVANCE"
                            onChange={this.onTermChange}
                          >
                            <Radio.Button value="ADVANCE">
                              In Advance
                            </Radio.Button>
                            <Radio.Button value="ARREAR">
                              in Arrear
                            </Radio.Button>
                          </Radio.Group>
                        </FormInput>
                      </Row>
                      <Row gutter={8}>
                        <FormInput col xs={12} name="gpduration">
                          <Input.Group compact>
                            <InputNumber
                              defaultValue="0"
                              size="middle"
                              min={0}
                              max={100}
                              step={1}
                              onChange={this.onGPDurationChange}
                            />

                            <Select
                              defaultValue="1"
                              size="middle"
                              onChange={this.onGpPeriodicityChange}
                            >
                              <option value="1"> 1</option>
                              <option value="2"> 2</option>
                              <option value="3"> 3</option>
                              <option value="6"> 6</option>
                              <option value="12"> 12</option>
                            </Select>
                          </Input.Group>
                        </FormInput>

                        <FormInput col xs={12} name="gpMethod">
                          <Radio.Group
                            size="middle"
                            defaultValue="CAP"
                            onChange={this.onGPMethodChange}
                          >
                            <Radio.Button value="CAP">
                              Capitalization
                            </Radio.Button>
                            <Radio.Button value="INT">
                              Int. Invoicing
                            </Radio.Button>
                          </Radio.Group>
                        </FormInput>
                      </Row>

                      <Row gutter={8}>
                        <FormInput col xs={12} name="residualValue">
                          <Input.Group compact>
                            <InputNumber
                              defaultValue="0"
                              value={this.state.rv}
                              size="middle"
                              onChange={this.onRVChange}
                              style={{ width: '120px' }}
                              formatter={(value) => toFormaterCurrency(value)}
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, '')
                              }
                            />
                            <InputNumber
                              size="middle"
                              style={{ width: '70px' }}
                              defaultValue={0}
                              value={this.state.rvPerc}
                              min={0}
                              max={100}
                              formatter={(value) => `${value}%`}
                              parser={(value) => value.replace('%', '')}
                              onChange={this.onRVPercChange}
                            />
                            <Button
                              type="default"
                              icon={
                                <ICalculator
                                  color={this.state.calStatusColor}
                                />
                              }
                              size="middle"
                              onClick={(e) => {
                                e.stopPropagation();
                                this.calculate('OUTSTAND');
                              }}
                            />
                          </Input.Group>
                        </FormInput>
                        <FormInput col xs={12} name="interestTerm">
                          <Radio.Group
                            defaultValue="BOP"
                            size="middle"
                            onChange={this.onInterestMethodChange}
                          >
                            <Radio.Button value="BOP">In Advance</Radio.Button>
                            <Radio.Button value="EOP">in Arrear</Radio.Button>
                          </Radio.Group>
                        </FormInput>
                      </Row>
                    </UtinaCard>
                    <UtinaCard comcode="vatDeferral" level={5}>
                      <Row>
                        <FormInput col xs={12} name="vatAmount">
                          <InputNumber
                            size="middle"
                            value={this.state.vatAmount}
                            onChange={this.onVatAmountChange}
                            style={{ width: '120px' }}
                            formatter={(value) => toFormaterCurrency(value)}
                            parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                          />
                        </FormInput>
                        <FormInput col xs={12} name="vatDuration">
                          <InputNumber
                            defaultValue={this.state.vatDuration}
                            value={this.state.vatDuration}
                            size="middle"
                            min={1}
                            max={360}
                            step={1}
                            onChange={this.onVatDurationChange}
                          />
                        </FormInput>
                        <FormInput col xs={12} name="vatInterestMethod">
                          <Select
                            defaultValue="SPLIT"
                            size="middle"
                            style={{ width: '100%' }}
                            onChange={this.onVatMethodChange}
                          >
                            <option value="SPLIT"> Split Over Schedule</option>
                            <option value="PERIODIC">Periodic Invoicing</option>
                            <option value="INTINVOICE">
                              Int. to Invoice with Reimb{' '}
                            </option>
                          </Select>
                        </FormInput>
                        <FormInput col xs={12} name="vatDaysBasis">
                          <Select
                            defaultValue="365"
                            size="middle"
                            onChange={this.onVatDaysBasisChange}
                          >
                            <option value="360">360 days</option>
                            <option value="365">365 days</option>
                          </Select>
                        </FormInput>
                      </Row>
                    </UtinaCard>
                  </Col>
                  <Col span={6}>
                    <UtinaCard comcode="rates" level={5}>
                      <FormInput col xs={24} name="rateType">
                        <Select
                          defaultValue="NOMINAL"
                          size="middle"
                          style={{ width: '100%' }}
                          onChange={this.onRateTypeChange}
                        >
                          <option value="NOMINAL"> Nominal Rate</option>
                          <option value="EFFECTIVE">Effective rate</option>
                          <option value="FLAT"> Flat Rate</option>
                          <option value="APR"> Annual Percentage Rate</option>
                          <option value="APRC">
                            {' '}
                            Annual Percentage Rate Of Charges
                          </option>
                          <option value="RATE000"> Rate/000-Coef</option>
                          <option value="MURABAHA"> Mourabaha Margin</option>
                        </Select>
                      </FormInput>

                      <Input.Group compact>
                        <FormInput col xs={20} name="rateValue">
                          <InputNumber
                            size="middle"
                            defaultValue={this.state.rateValue}
                            onChange={this.onRateValueChange}
                          />
                        </FormInput>
                        <Button
                          type="default"
                          icon={
                            <ICalculator color={this.state.calStatusColor} />
                          }
                          size="middle"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.calculate('RATE');
                          }}
                        />
                      </Input.Group>

                      <FormInput col xs={24} name="fundingRate">
                        <InputNumber
                          size="middle"
                          defaultValue={this.state.fundingRate}
                          value={this.state.fundingRate}
                          onChange={this.onFundingRateChange}
                        />
                      </FormInput>
                      <FormInput col xs={24} name="spread">
                        <InputNumber
                          size="middle"
                          defaultValue={this.state.spread}
                          value={this.state.spread}
                          onChange={this.onSpreadChange}
                        />
                      </FormInput>
                      <FormInput col xs={24} name="profitabilityRate">
                        <InputNumber
                          size="middle"
                          value={this.state.profitabilityRate}
                          onChange={this.onProfitabilityRateChange}
                        />
                      </FormInput>

                      <FormInput col xs={24} name="daysBasis">
                        <Select
                          defaultValue="360"
                          size="middle"
                          onChange={this.onCountingBasisChange}
                        >
                          <option value="360">360 days</option>
                          <option value="365">365 days</option>
                          <option value="F360">full Year on 360 days</option>
                        </Select>
                      </FormInput>

                      <Row gutter={8}>
                        <FormInput col xs={24} name="flatRate">
                          <Text type="danger">
                            {toRate(this.state.flatRate)}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="rate000">
                          <Text type="danger">
                            {toRate(this.state.rate000)}
                          </Text>
                        </FormInput>

                        <FormInput col xs={24} name="aprRate">
                          <Text type="danger">
                            {toRate(this.state.aprRate)}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="marginImpactCredit">
                          <Text type="danger">
                            {toRate(this.state.marginImpactCredit)}
                          </Text>
                        </FormInput>
                        <FormInput col xs={24} name="marginImpactDebit">
                          <Text type="danger">
                            {toRate(this.state.marginImpactDebit)}
                          </Text>
                        </FormInput>
                      </Row>
                      <FormInput col xs={24} name="nominalRate">
                        <Input.Group compact>
                          <InputNumber
                            size="middle"
                            value={this.state.nominalRate}
                          />
                          <Button
                            icon={
                              <ICalculator color={this.state.calStatusColor} />
                            }
                            size="middle"
                          >
                            {'Convert-->'}
                          </Button>
                        </Input.Group>
                      </FormInput>
                      <FormInput col xs={24} name="effectiveRate">
                        <Input.Group compact>
                          <InputNumber
                            size="middle"
                            value={this.state.effectiveRate}
                          />
                          <Button
                            icon={
                              <ICalculator color={this.state.calStatusColor} />
                            }
                            size="middle"
                          >
                            {'<--Convert'}
                          </Button>
                        </Input.Group>
                      </FormInput>
                    </UtinaCard>
                  </Col>
                </Row>
              </TabPane>
              <TabPane
                forceRender
                tab={
                  <Badge style={{ backgroundColor: '#52c41a' }}>
                    <GetLabel label="Cost of Fund & Margin Analysis" />
                  </Badge>
                }
                key="2"
                style={{ fontSize: 16 }}
              >
                <Card type="inner">
                  <Row gutter={8}>&nbsp;</Row>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="FundingRate" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <InputNumber
                        size="middle"
                        value={this.state.fundingRate}
                        onChange={this.onFundingRateChange}
                      />
                    </Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="FundingPeriodicity" />
                      &nbsp;{' '}
                    </Col>
                    <Col span={7}>
                      <Input.Group compact>
                        <Select
                          defaultValue="1"
                          size="middle"
                          onChange={this.onFundingPeriodicityChange}
                        >
                          <option value="1"> 1</option>
                          <option value="2"> 2</option>
                          <option value="3"> 3</option>
                          <option value="4"> 4</option>
                          <option value="5"> 5</option>
                          <option value="6"> 6</option>
                          <option value="7"> 7</option>
                          <option value="8"> 8</option>
                          <option value="9"> 9</option>
                          <option value="10"> 10</option>
                          <option value="11"> 11</option>
                          <option value="12"> 12</option>
                        </Select>
                        <Button
                          type="default"
                          icon={
                            <ICalculator color={this.state.calStatusColor} />
                          }
                          size="middle"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.calculate('INST');
                          }}
                        />
                      </Input.Group>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="Installmentamount" />
                      &nbsp;{' '}
                    </Col>
                    <Col span={7}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.fundingInstallment,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Divider>
                    <GetLabel label="MarginAnalysis" />{' '}
                  </Divider>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="investAmount" />
                      &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.InvestAmount,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="CustomerRate" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">{toRate(this.state.rateValue)}</Text>
                      &nbsp;
                      <Text>{this.state.rateType}</Text>
                    </Col>
                  </Row>

                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="totalInterest" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.totalInterest,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="totalRentalPayment" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.totalRental,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>
                  </Row>

                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="totalFees" />
                      &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(this.state.feesAmount, this.state.currcode)}
                      </Text>
                    </Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="APR" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">{toRate(this.state.aprRate)}</Text>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="totalParticipation" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.oemPartAmount +
                            this.state.dealerPartAmount,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="FlatRate" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">{toRate(this.state.flatRate)}</Text>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="totalCommission" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.commissionAmount,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>

                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="Rate/000" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">{toRate(this.state.rate000)}</Text>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="ProfitaAmountbeforeFund" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.profitabilityAmount,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="ProfitRateBefoFunding" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toRate(this.state.profitabilityRate)}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="totalCostofFund" /> &nbsp; &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.totalFundingInterest,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>
                  </Row>

                  <Row gutter={8}>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="NetMargin" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toCurrency(
                          this.state.profitabilityAmount -
                            this.state.totalFundingInterest,
                          this.state.currcode
                        )}
                      </Text>
                    </Col>
                    <Col span={5} style={{ textAlign: 'right' }}>
                      <GetLabel label="MarginRate" /> &nbsp;{' '}
                    </Col>
                    <Col span={4} style={{ textAlign: 'left', color: 'red' }}>
                      <Text type="danger">
                        {toRate(
                          this.state.profitabilityRate - this.state.fundingRate
                        )}
                      </Text>
                    </Col>
                  </Row>
                </Card>
              </TabPane>
              <TabPane
                forceRender
                tab={
                  <Badge style={{ backgroundColor: '#52c41a' }}>
                    <GetLabel label="paymentSchedule" />
                  </Badge>
                }
                key="3"
              >
                <Table
                  forceRender
                  pagination={{
                    pageSize: 1000,
                  }}
                  name="psTable"
                  dataSource={this.state.paymentSchedule}
                  columns={getRespColumnsPS()}
                  size="middle"
                  scroll={{
                    x: 1400,
                    y: 450,
                  }}
                  summary={() => (
                    <Table.Summary fixed>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} />
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3}>
                          <Text type="danger" strong>
                            Total :
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={4} align="right">
                          {toCurrency(
                            this.state.totalVatDeffered,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={5} align="right">
                          {toCurrency(
                            this.state.totalAmortization,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={6} align="right">
                          {toCurrency(
                            this.state.totalInterest,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8} />
                        <Table.Summary.Cell index={9} align="right">
                          {toCurrency(
                            this.state.totaldiscountedOutstanding,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>

                        <Table.Summary.Cell index={10} align="right">
                          {toCurrency(
                            this.state.totaldiscountedInterest,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={11} align="right">
                          {toCurrency(
                            this.state.totalAgiosdeb,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={12} align="right">
                          {toCurrency(
                            this.state.totaldiscountedAgiosdeb,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={13} />
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                        <Table.Summary.Cell index={18} />
                        <Table.Summary.Cell index={19} align="right">
                          {toCurrency(
                            this.state.totalRental,
                            this.state.currcode ??
                              localStorage.getItem('currcode') ??
                              ''
                          )}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2}>
                          <Text type="danger" strong>
                            DGO :
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} align="left">
                          {toCurrency(this.state.dgo, this.state.currcode)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={2}>
                          <Text type="danger" strong>
                            Margin Impact :
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={3} align="left">
                          {toRate(this.state.marginImpactCredit)}
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={4}>
                          <Text type="danger" strong>
                            Margin Impact :
                          </Text>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={5} align="left">
                          {toRate(this.state.marginImpactDebit)}
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    </Table.Summary>
                  )}
                />
              </TabPane>
              <TabPane
                forceRender
                tab={
                  <Badge style={{ backgroundColor: '#52c41a' }}>
                    <GetLabel label="fundingSchedule" />
                  </Badge>
                }
                key="4"
              >
                <Table
                  forceRender
                  pagination={{
                    pageSize: 1000,
                  }}
                  name="fundingTable"
                  dataSource={this.state.fundingSchedule}
                  columns={getRespColumnsPS()}
                  size="middle"
                  scroll={{
                    x: 1400,
                    y: 450,
                  }}
                />
              </TabPane>
            </Tabs>
          </Card>
        </Suspense>
      </Form>
    );

    return (
      (<DF.Provider pagcode="calculator">
        <ModalControllerNV
          modal={({ setVisible, visible }) => (
            <Modal
              open={visible}
              onCancel={() => {
                setVisible(false);
              }}
              width={1500}
              style={{ top: '20px', height: '400px' }}
              destroyOnClose
              footer={false}
            >
              {contentCalculator}
            </Modal>
          )}
          content={({ setVisible, visible }) => (
            <a onClick={() => setVisible(true)}>
              <span className={`action account`}>
                <ICalculator color="#722ED1" />
                <span className={'name'}>
                  <GetLabel
                    label="calculator"
                    Inspectstyle={{ marginTop: '15px' }}
                  />
                </span>
              </span>
            </a>
          )}
        />
      </DF.Provider>)
    );
  }
}

export default Calculator;
